var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    viewBox: "0 0 150 150",
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.742 13.316H138V35H1.742zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.742 39H138v16H1.742zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.742 59H138v59H1.742zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 76h52.992v53.566H95zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M137.605 28.953c0-8.617-7.011-15.633-15.628-15.633H17.379c-8.621 0-15.633 7.016-15.633 15.633v6.027h135.86zm0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M1.746 39.988h135.86v14.106H1.745zm0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M121.973 71.125a31.884 31.884 0 0 1 15.632 4.074V59.102H1.746v43.156c0 8.625 7.012 15.64 15.633 15.64h76.328a31.65 31.65 0 0 1-3.687-14.87c0-17.59 14.332-31.903 31.953-31.903zM40.21 89.02H15.883a2.507 2.507 0 0 1-2.508-2.504 2.508 2.508 0 0 1 2.508-2.508H40.21a2.506 2.506 0 0 1 0 5.012zM69.68 75.875H15.883a2.505 2.505 0 1 1 0-5.008H69.68c1.382 0 2.5 1.117 2.5 2.504a2.5 2.5 0 0 1-2.5 2.504zm0 0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f4482",
    d: "M136.613 81.277c-.043-.03-.086-.062-.129-.09a26.212 26.212 0 0 0-14.511-4.363c-14.477 0-26.254 11.758-26.254 26.203 0 14.453 11.777 26.207 26.254 26.207 14.48 0 26.261-11.754 26.261-26.207 0-8.746-4.343-16.867-11.62-21.75zm-1.535 15.57-11.09 15.305a2.501 2.501 0 0 1-1.976 1.032h-.051a2.49 2.49 0 0 1-1.965-.954l-8.644-10.96a2.505 2.505 0 1 1 3.933-3.102l6.594 8.36 9.14-12.618a2.506 2.506 0 0 1 4.06 2.938zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.4ff62344eacff76b745601f03da59c8a.svg";
export { ForwardRef as ReactComponent };